import BrandFullName from "../../brand_fullname/brand_fullname.component";
import {
  navItems,
  handleClick,
  handleLogout,
} from "./restaurant-navigation.utils";
import "./restaurant-navigation.styles.scss";
import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Brand from "../../brand/brand.component";
import { UserContext } from "../../../contexts/users.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
const RestaurantNavigation = () => {
  const [navValues, setNavValues] = useState(navItems);
  const navigate = useNavigate();
  const navigateFunction = (location) => {
    navigate(location);
  };

  const [navigationModal, setNavigationModal] = useState(
    "navigation-modal-close"
  );

  const handleNavigationModal = () => {
    if (navigationModal === "navigation-modal-close") {
      setNavigationModal("navigation-modal-open");
    } else if (navigationModal === "navigation-modal-open") {
      setNavigationModal("navigation-modal-close");
    }
  };
  const closeNavigationModal = () => {
    setNavigationModal("navigation-modal-close");
  };
  const { user } = useContext(UserContext);
  useEffect(() => {
    const localValue = localStorage.getItem("navigationFolder");

    const newObject = {
      HOME: "",
      MENU: "",
      ACCOUNTS: "",
      CUSTOMER_CENTER: "",
      SETTINGS: "",
    };
    setNavValues({ ...newObject, [localValue]: "active" });
    if (user === "") {
      navigate("/");
    } else {
      if (localValue === "HOME") {
        navigate("/home");
      } else {
        navigate(localValue.toLowerCase());
      }
    }
  }, []);
  return (
    <div className="restaurant-navigation-container">
      <div className="restaurant-home-navigation">
        {window.innerWidth > 1024 ? (
          <div className="restaurant-home-navigation-desktop">
            <div
              onClick={() => {
                handleClick(setNavValues, "HOME", navigateFunction);
                navigate("/home");
              }}
            >
              <BrandFullName />
            </div>

            <div className="restaurant-navitems">
              {Object.keys(navValues).map((index) => {
                const classValue = "restaurant-navitem " + navValues[index];
                const value = index.replace("_", " ");
                return (
                  <span
                    key={index}
                    className={classValue}
                    onClick={() => {
                      handleClick(setNavValues, index, navigateFunction);
                    }}
                  >
                    {value}
                  </span>
                );
              })}
              <span className="restaurant-navitem" onClick={handleLogout}>
                LOG OUT
              </span>
            </div>
          </div>
        ) : (
          <div className="restaurant-home-navigation-mobile">
            <div
              onClick={() => {
                handleClick(setNavValues, "HOME", navigateFunction);
                navigate("/home");
              }}
            >
              <Brand />
            </div>
            <div className="rh-navigation-open">
              <span
                className="rh-navigation-open-button"
                onClick={handleNavigationModal}
              >
                <FontAwesomeIcon icon={faBars} />
              </span>
            </div>

            <div className={navigationModal}>
              <div className="restaurant-navitems">
                <span
                  className="restaurant-navitems-close"
                  onClick={handleNavigationModal}
                >
                  X
                </span>
                {Object.keys(navValues).map((index) => {
                  const classValue = "restaurant-navitem " + navValues[index];
                  const value = index.replace("_", " ");
                  return (
                    <span
                      key={index}
                      className={classValue}
                      onClick={() => {
                        handleNavigationModal();
                        handleClick(setNavValues, index, navigateFunction);
                      }}
                    >
                      {value}
                    </span>
                  );
                })}
                <span className="restaurant-navitem" onClick={handleLogout}>
                  LOG OUT
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="restaurant-content" onClick={closeNavigationModal}>
        <Outlet />
      </div>
    </div>
  );
};

export default RestaurantNavigation;
